export const COLORS = {
  primary: "#4F78A1",
  primaryDark: "#28323e",
  primaryHover: "#1c2530",

  textBody: "#28323e",
  textMuted: "#6b7280",
  textSubtle: "#9ca3af",
  textOnPrimary: "#ffffff",

  surface: "#ffffff",
  surfaceMuted: "#f3f6fb",
  surfaceHover: "#fafcfb",
  surfaceSelected: "#e8f0fb",
  border: "#e5e7eb",
  borderSoft: "#eef0f3",
  borderCard: "#e9eef3",
  divider: "#f0f0f0",
  entriesbg: "#DAEEFF",
  pageGradientStart: "#f8fafc",
  pageGradientEnd: "#f8fafc",

  successBg: "#DAEEFF",
  successText: "#4F78A1",
  unsuccessBg: "#FFE6E3",
  unsuccessText: "#dc2626",
  pendingBg: "#FFEDC2",
  pendingText: "#B45309",
  authorizedBg: "#C3F5DE",
  authorizedText: "#16a34a",

  trendPositiveBg: "#C3F5DE",
  trendPositiveText: "#16a34a",
  trendNegativeBg: "#FFE6E3",
  trendNegativeText: "#dc2626",

  iconCircleBg: "#eaf3f4",
  iconNotificationBg: "#E5EFFF",
  exportGreen: "#16a34a",
  exportGreenHover: "#15803d",

  // Analytics chart lines, each paired with the same colour at 30% for the
  // area gradient beneath the line.
  chartSuccessLine: "#00a263",
  chartSuccessFill: "rgba(0, 162, 99, 0.3)",
  chartUnsuccessLine: "#db9c9d",
  chartUnsuccessFill: "rgba(219, 156, 157, 0.3)",

  chartScheduledLine: "#0064a2",
  chartScheduledFill: "rgba(0, 100, 162, 0.3)",
  chartRescheduledLine: "#db9c9d",
  chartRescheduledFill: "rgba(219, 156, 157, 0.3)",
  chartCancelledLine: "#7f5bb6",
  chartCancelledFill: "rgba(127, 91, 182, 0.3)",
  chartApptUnsuccessLine: "#b58629",
  chartApptUnsuccessFill: "rgba(181, 134, 41, 0.3)",
  chartGrid: "#eef0f3",
  chartAxis: "#9ca3af",
  chartCrosshair: "#cbd5e1",
  chartMarkerFill: "#ffffff",
} as const;

export type ColorKey = keyof typeof COLORS;
